import styled from 'styled-components';

import theme from './theme';

const OptionNutrition = styled.h5`
  color: ${theme.optionNutritionColor};
  font-weight: normal;
  margin: 0;
  padding: 0;
`;

export default OptionNutrition;
